import { useQuery } from 'react-query'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { endpoints } from '@app/api/config'
import {
  ApiBillingInfo,
  ApiErrorResponse,
  ApiResponseBillingInfo,
} from 'BackendApi'
import { getRandomExampleHeader } from '@app/api/utils/mock'

const fetchBillingInfo = async (): Promise<ApiBillingInfo | undefined> => {
  const apiResponse = await apiAuthClient.get<ApiResponseBillingInfo>(
    endpoints.billingInfo,
    {
      headers: {
        /* ...getRandomExampleHeader(['empty']), */
        /* ...getRandomExampleHeader(['example-1']), */
        ...getRandomExampleHeader(['no-company-name']),
      },
    }
  )
  // data normalization
  const billingData = apiResponse.data.data
  if (billingData) {
    return {
      ...billingData, // preserve any other fields
      companyName: billingData.companyName || '',
      state: billingData.state || '',
      zip: billingData.zip || '',
      phone: billingData.phone || '',
      country: billingData.country || '',
    }
  }
  return billingData
}

export const useGetBillingInfo = () =>
  useQuery<ApiBillingInfo | undefined, ApiErrorResponse>(
    ['billingInfo'],
    fetchBillingInfo
  )
